<script>
/*
<template>
    <span class="ec-inline-editable-variable" @click.stop="callModal">{{ value | numberFormater }}</span>
</template>
*/
import { placeholderFormater } from '../../utility'

export default Vue.component('editable-variable', {
    name: "EditableVariable",
    data: function() { return {
      'variableData': null,
      'variable': null,
      'value': "0",
      'decimals': 0,
      'orginalState': null,
      'min': 0,
      'max': null
    }},
    computed: {
      vContent: function() {
          return this.value
      },
      disabled: function() {
          return this.$store.readOnly
      }
    },
    watch: {
        vContent: {
            handler: function() {
                this.$nextTick(function() {
                    placeholderFormater(this.$el, this.decimals)
                })
            },
        },
        disabled: {
            handler: function(value) {
                this.$nextTick(() => {
                    if(value) {
                        this.$el.classList.add("disabled")
                    } else {
                        this.$el.classList.remove("disabled")
                    }  
                })             
            },
            immediate: true
        }
    },
    beforeMount() {
        this.$store.pageVariables.push(this.variable)
    },
    mounted() {
        this.$nextTick(function() {
            placeholderFormater(this.$el, this.decimals)
        })
    },
    methods: {
        callModal(event) {
            if(this.disabled) {
                return
            }

            if(this.effectedWarningEnabled) {
                this.$event.$emit('call-change-warning-modal')
                event.preventDefault(event)
                return
            }

            this.$event.$emit('change-variable', {
                variable: this.variable,
                initValue: this.value,
                orginalValue: this.orginalState,
                orginalStateDecimals: this.decimals,
                variableData: this.variableData
            }, this)
        }
    }
})
</script>
